<template>
  <BInputGroup :size="size">
    <template v-if="$slots.prependText || $slots.prepend"
              #prepend>
      <slot name="prepend">
        <BInputGroupText>
          <slot name="prependText"></slot>
        </BInputGroupText>
      </slot>
    </template>
    <!-- eslint-disable vue/no-deprecated-dollar-listeners-api -->
    <TextInput v-bind="$attrs"
               ref="textInput"
               :value="value"
               :state="state"
               :type="type"
               v-on="$listeners"></Textinput>
    <!-- eslint-enable -->
    <template v-if="$slots.appendText || $slots.append"
              #append>
      <slot name="append">
        <BInputGroupText>
          <slot name="appendText"></slot>
        </BInputGroupText>
      </slot>
    </template>
  </BInputGroup>
</template>

<script>
  import { BInputGroup, BInputGroupText } from 'bootstrap-vue';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';
  import TextInput from './TextInput.vue';

  export default {
    name: 'TextInputGroup',
    components: {
      BInputGroup,
      BInputGroupText,
      TextInput,
    },
    inheritAttrs: false,
    props: {
      value: {
        type: String,
      },
      size: {
        type: String,
        default: BootstrapVariant.MEDIUM,
      },
      state: {
        type: [Boolean, null],
        default: null,
      },
      type: {
        type: String,
        default: 'text',
      },
    },
    expose: ['focus', 'blur'],
    methods: {
      focus() {
        this.$refs.textInput.focus();
      },
      blur() {
        this.$refs.textInput.blur();
      },
    },
  };
</script>
